// extracted by mini-css-extract-plugin
export var title = "BlogArchivePage-module--title--219tD";
export var container = "BlogArchivePage-module--container--Va6-F";
export var section = "BlogArchivePage-module--section--mN2Vu";
export var year = "BlogArchivePage-module--year--7wccP";
export var post = "BlogArchivePage-module--post--7BbOJ";
export var iconExternal = "BlogArchivePage-module--iconExternal--I1LGe";